import { render, staticRenderFns } from "./travelAgencyListNew.vue?vue&type=template&id=36bf4642&scoped=true"
import script from "./travelAgencyListNew.vue?vue&type=script&lang=js"
export * from "./travelAgencyListNew.vue?vue&type=script&lang=js"
import style0 from "./travelAgencyListNew.vue?vue&type=style&index=0&id=36bf4642&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bf4642",
  null
  
)

export default component.exports